import styled from "@emotion/styled";

import { ContentItemRender } from "~/components/content/content-item-render";

export const StyledContentItemRender = styled(ContentItemRender)``;

export const Container = styled.div``;
